import forgetPassword from "./forgetPassword";

export default forgetPassword;
